import { NavLink as RouterNavLink } from "react-router-dom";
import { cn } from "../../lib/cn";
import { useAuth } from "../../lib/auth";
import { filterNav, type NavLink } from "./navModel";

export function SideNav({ links, title }: { links: NavLink[]; title: string }) {
  const { isAuthenticated, isLinked, hasRole, user } = useAuth();
  const visible = filterNav(links, {
    authenticated: isAuthenticated,
    linked: isLinked,
    email: user?.email,
    hasRole,
  });

  return (
    <nav aria-label={title} className="etheria-panel h-fit min-w-0 overflow-hidden p-2 lg:sticky lg:top-[88px]">
      <div className="mb-2 border-b border-iron-300/45 px-3 pb-3 pt-2">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.14em] text-arcane-100">{title}</p>
        <p className="mt-1 text-[10px] uppercase tracking-[0.1em] text-parchment-200/35">Registre de navigation</p>
      </div>
      <ul className="touch-scroll -mx-2 flex gap-1 overflow-x-auto px-2 pb-1 lg:mx-0 lg:flex-col lg:overflow-visible lg:px-0 lg:pb-0">
        {visible.map((link) => (
          <li key={link.to} className="shrink-0 lg:shrink">
            <RouterNavLink
              to={link.to}
              end={link.to === "/panel" || link.to === "/admin"}
              className={({ isActive }) => cn(
                "block min-h-10 whitespace-nowrap rounded border border-transparent px-3 py-2 text-sm transition-colors",
                isActive
                  ? "border-arcane-400/25 bg-arcane-600/20 font-semibold text-arcane-100 shadow-[inset_3px_0_0_0_#44b6a4]"
                  : "text-parchment-200/65 hover:border-iron-300/35 hover:bg-iron-500/30 hover:text-parchment-50",
              )}
            >
              {link.label}
            </RouterNavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
